const Field = require("components/fields/base/Field");

class Input extends Field {

    get defaultType() {
        return 'text';
    }

    get type() {
        if (this.props.type) {
            return this.props.type;
        }
        return this.defaultType;
    }

    get extendedInputProps() {
        return {};
    }

    renderField() {

        let optionalProps = {};

        if(this.isReadonly === true){
            optionalProps.readOnly = true;
        }

        return (
            <input ref={this.field_ref}
                   id={this.id}
                   type={this.type}
                   name={this.as}
                   onBlur={this._onBlur.bind(this)}
                   onChange={this._onChange.bind(this)}
                   defaultValue={this.value}
                   disabled={this.isDisabled}
                   placeholder={this.placeholder}
                   maxLength={this.props.maxLength}
                   {...optionalProps}
                   {...this.extendedInputProps} />
        );
    }

}

module.exports = Input;
